import React from 'react';
import { Flag } from 'semantic-ui-react';
import "../css/LanguageChange.css";
import {changeLanguage} from "../actions"
import {store} from "../index"

const LanguageChange = (props) => {
    console.log(`store`, store);
    return (
        <div>
            <Flag 
            onClick={  ()    =>  store.dispatch(changeLanguage("pl")    )} 
            className="language-icon" name="pl"  />
            <Flag 
            onClick={  ()    =>  store.dispatch(changeLanguage("us")    )} 
            className="language-icon" name="us" />
            <Flag 
            onClick={  ()    =>  store.dispatch(changeLanguage("ru")    )} 
            className="language-icon" name="ru" />
        </div>
    )
}

export default LanguageChange
